// Auto generated file, do not manually modify!
// com.hotpads.usermanagement.api.tools.UserManagementCompanyDetailsToolsApiHandler

import { getClient } from '../../client';
import { httpApiRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AddAdminUserRequestDto,
  AddNonAdminUserRequestDto,
  InviteUserToCompanyRequestDto,
  MergeCompaniesRequestDto,
  RenameCompanyRequestDto,
  ToggleNonAdvertiserRequestDto,
  UmcApplicationPermissionDetails,
  UmcCustomerDto,
  UmcSecondaryUserDto,
  UmcStatusesDto,
  UmcUserDetailsDto,
  UpdateNonAdvertiserZrnRequestDto,
  UserManagementCreateUpdateCompanyResponseDto,
} from '../..';

interface GetApplicationPermissionDetailsParams {
  umcId: string;
}
interface GetAssociatedCustomersParams {
  umcId: string;
}
interface GetCompanyStatusesParams {
  umcId: string;
}
interface GetCompanyUserDetailsParams {
  umcId: string;
}
interface GetSecondaryUsersParams {
  umcId: string;
}

export const UserManagementCompanyDetailsToolsApiHandler_addAdminUser_Path =
  '/apiTools/userManagementCompanyDetails/addAdminUser';

export const UserManagementCompanyDetailsToolsApiHandler_addAdminUser = (
  postData: AddAdminUserRequestDto,
  client = getClient(),
) => {
  return httpApiRequest<never, AddAdminUserRequestDto, void>(
    {
      endpoint: UserManagementCompanyDetailsToolsApiHandler_addAdminUser_Path,
      method: 'POST',
      contextPath: '/user-management',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const UserManagementCompanyDetailsToolsApiHandler_addNonAdminUser_Path =
  '/apiTools/userManagementCompanyDetails/addNonAdminUser';

export const UserManagementCompanyDetailsToolsApiHandler_addNonAdminUser = (
  postData: AddNonAdminUserRequestDto,
  client = getClient(),
) => {
  return httpApiRequest<never, AddNonAdminUserRequestDto, void>(
    {
      endpoint: UserManagementCompanyDetailsToolsApiHandler_addNonAdminUser_Path,
      method: 'POST',
      contextPath: '/user-management',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const UserManagementCompanyDetailsToolsApiHandler_disableApplicationPermissions_Path =
  '/apiTools/userManagementCompanyDetails/disableApplicationPermissions';

export const UserManagementCompanyDetailsToolsApiHandler_disableApplicationPermissions = (
  postData: string,
  client = getClient(),
) => {
  return httpApiRequest<never, string, void>(
    {
      endpoint: UserManagementCompanyDetailsToolsApiHandler_disableApplicationPermissions_Path,
      method: 'POST',
      contextPath: '/user-management',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const UserManagementCompanyDetailsToolsApiHandler_getApplicationPermissionDetails_Path =
  '/apiTools/userManagementCompanyDetails/getApplicationPermissionDetails';

export const UserManagementCompanyDetailsToolsApiHandler_getApplicationPermissionDetails = (
  getParams: GetApplicationPermissionDetailsParams,
  client = getClient(),
) => {
  return httpApiRequest<GetApplicationPermissionDetailsParams, never, UmcApplicationPermissionDetails>(
    {
      getParams: getParams,
      endpoint: UserManagementCompanyDetailsToolsApiHandler_getApplicationPermissionDetails_Path,
      method: 'GET',
      contextPath: '/user-management',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const UserManagementCompanyDetailsToolsApiHandler_getAssociatedCustomers_Path =
  '/apiTools/userManagementCompanyDetails/getAssociatedCustomers';

export const UserManagementCompanyDetailsToolsApiHandler_getAssociatedCustomers = (
  getParams: GetAssociatedCustomersParams,
  client = getClient(),
) => {
  return httpApiRequest<GetAssociatedCustomersParams, never, Array<UmcCustomerDto>>(
    {
      getParams: getParams,
      endpoint: UserManagementCompanyDetailsToolsApiHandler_getAssociatedCustomers_Path,
      method: 'GET',
      contextPath: '/user-management',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const UserManagementCompanyDetailsToolsApiHandler_getCompanyStatuses_Path =
  '/apiTools/userManagementCompanyDetails/getCompanyStatuses';

export const UserManagementCompanyDetailsToolsApiHandler_getCompanyStatuses = (
  getParams: GetCompanyStatusesParams,
  client = getClient(),
) => {
  return httpApiRequest<GetCompanyStatusesParams, never, UmcStatusesDto>(
    {
      getParams: getParams,
      endpoint: UserManagementCompanyDetailsToolsApiHandler_getCompanyStatuses_Path,
      method: 'GET',
      contextPath: '/user-management',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const UserManagementCompanyDetailsToolsApiHandler_getCompanyUserDetails_Path =
  '/apiTools/userManagementCompanyDetails/getCompanyUserDetails';

export const UserManagementCompanyDetailsToolsApiHandler_getCompanyUserDetails = (
  getParams: GetCompanyUserDetailsParams,
  client = getClient(),
) => {
  return httpApiRequest<GetCompanyUserDetailsParams, never, Array<UmcUserDetailsDto>>(
    {
      getParams: getParams,
      endpoint: UserManagementCompanyDetailsToolsApiHandler_getCompanyUserDetails_Path,
      method: 'GET',
      contextPath: '/user-management',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const UserManagementCompanyDetailsToolsApiHandler_getSecondaryUsers_Path =
  '/apiTools/userManagementCompanyDetails/getSecondaryUsers';

export const UserManagementCompanyDetailsToolsApiHandler_getSecondaryUsers = (
  getParams: GetSecondaryUsersParams,
  client = getClient(),
) => {
  return httpApiRequest<GetSecondaryUsersParams, never, Array<UmcSecondaryUserDto>>(
    {
      getParams: getParams,
      endpoint: UserManagementCompanyDetailsToolsApiHandler_getSecondaryUsers_Path,
      method: 'GET',
      contextPath: '/user-management',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const UserManagementCompanyDetailsToolsApiHandler_inviteUserToCompany_Path =
  '/apiTools/userManagementCompanyDetails/inviteUserToCompany';

export const UserManagementCompanyDetailsToolsApiHandler_inviteUserToCompany = (
  postData: InviteUserToCompanyRequestDto,
  client = getClient(),
) => {
  return httpApiRequest<never, InviteUserToCompanyRequestDto, void>(
    {
      endpoint: UserManagementCompanyDetailsToolsApiHandler_inviteUserToCompany_Path,
      method: 'POST',
      contextPath: '/user-management',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const UserManagementCompanyDetailsToolsApiHandler_mergeCompanies_Path =
  '/apiTools/userManagementCompanyDetails/mergeCompanies';

export const UserManagementCompanyDetailsToolsApiHandler_mergeCompanies = (
  postData: MergeCompaniesRequestDto,
  client = getClient(),
) => {
  return httpApiRequest<never, MergeCompaniesRequestDto, void>(
    {
      endpoint: UserManagementCompanyDetailsToolsApiHandler_mergeCompanies_Path,
      method: 'POST',
      contextPath: '/user-management',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const UserManagementCompanyDetailsToolsApiHandler_removeUser_Path =
  '/apiTools/userManagementCompanyDetails/removeUser';

export const UserManagementCompanyDetailsToolsApiHandler_removeUser = (postData: string, client = getClient()) => {
  return httpApiRequest<never, string, void>(
    {
      endpoint: UserManagementCompanyDetailsToolsApiHandler_removeUser_Path,
      method: 'POST',
      contextPath: '/user-management',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const UserManagementCompanyDetailsToolsApiHandler_renameCompany_Path =
  '/apiTools/userManagementCompanyDetails/renameCompany';

export const UserManagementCompanyDetailsToolsApiHandler_renameCompany = (
  postData: RenameCompanyRequestDto,
  client = getClient(),
) => {
  return httpApiRequest<never, RenameCompanyRequestDto, UserManagementCreateUpdateCompanyResponseDto>(
    {
      endpoint: UserManagementCompanyDetailsToolsApiHandler_renameCompany_Path,
      method: 'POST',
      contextPath: '/user-management',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const UserManagementCompanyDetailsToolsApiHandler_toggleNonAdvertiser_Path =
  '/apiTools/userManagementCompanyDetails/toggleNonAdvertiser';

export const UserManagementCompanyDetailsToolsApiHandler_toggleNonAdvertiser = (
  postData: ToggleNonAdvertiserRequestDto,
  client = getClient(),
) => {
  return httpApiRequest<never, ToggleNonAdvertiserRequestDto, void>(
    {
      endpoint: UserManagementCompanyDetailsToolsApiHandler_toggleNonAdvertiser_Path,
      method: 'POST',
      contextPath: '/user-management',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const UserManagementCompanyDetailsToolsApiHandler_updateNonAdvertiserZrn_Path =
  '/apiTools/userManagementCompanyDetails/updateNonAdvertiserZrn';

export const UserManagementCompanyDetailsToolsApiHandler_updateNonAdvertiserZrn = (
  postData: UpdateNonAdvertiserZrnRequestDto,
  client = getClient(),
) => {
  return httpApiRequest<never, UpdateNonAdvertiserZrnRequestDto, void>(
    {
      endpoint: UserManagementCompanyDetailsToolsApiHandler_updateNonAdvertiserZrn_Path,
      method: 'POST',
      contextPath: '/user-management',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};
